import { render } from "./RouteInfoPage.vue?vue&type=template&id=2abbd47c&scoped=true"
import script from "./RouteInfoPage.vue?vue&type=script&lang=js"
export * from "./RouteInfoPage.vue?vue&type=script&lang=js"

import "./RouteInfoPage.vue?vue&type=style&index=0&id=2abbd47c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2abbd47c"]])

export default __exports__